//src/assets/mockdata/Claims/claimFeatureData.ts
import {
  Attachment,
  Claim,
  ClaimStatus,
  Note,
  Procedure,
  ProcedureSource,
  ProcedureStatus,
  Appointment,
  TreatmentPlan,
  InsurancePayment,
  StatusTypes,
} from '@dataTypes/claimFeature.types'

const mockNotes: Note[] = [
  {
    noteId: 'CN-1',
    author: 'Dr. John Doe',
    content: 'Initial consultation and X-ray taken.',
    date: '2025-02-10',
  },
  {
    noteId: 'CN-2',
    author: 'Dr. Jane Smith',
    content: 'Follow-up procedure scheduled.',
    date: '2025-02-12',
  },
]

const mockAttachments: Attachment[] = [
  {
    itemNo: 'CA-1',
    item: 'X-ray',
    formatType: 'Image',
    orientation: 'Landscape',
    dateTaken: '2025-02-10',
    fileName: 'xray_feb10.png',
    isEditing: false,
    size: 204800,
    notes: [mockNotes[0]],
  },
  {
    itemNo: 'CA-2',
    item: 'Insurance Form',
    formatType: 'PDF',
    orientation: 'Portrait',
    dateTaken: '2025-02-11',
    fileName: 'insurance_form.pdf',
    isEditing: false,
    size: 1024000,
    notes: [],
  },
]

const mockInsurancePayments: InsurancePayment[] = [
  {
    id: 'pay-002',
    checkNumber: 'CHK123456',
    bankName: 'TRUSTBANK',
    depositDate: '2024-03-01',
    eobNumber: 'EOB654321',
  },
  {
    id: 'pay-003',
    checkNumber: 'CHK789123',
    bankName: 'WESTBANK',
    depositDate: '2024-03-05',
    eobNumber: 'EOB321987',
  },
  {
    id: 'pay-004',
    checkNumber: 'CHK456789',
    bankName: 'PENBANK',
    depositDate: '2024-03-10',
    eobNumber: 'EOB987123',
  },
]

const mockProcedures: Procedure[] = [
  {
    procedureId: 'PR0C-1',
    procedureName: 'Teeth Cleaning',
    procedureCode: 'D1110',
    procedureDate: '2025-02-11',
    provider: 'Dr. John Doe',
    providerFirstName: 'John',
    providerLastName: 'Doe',
    coverage: '80%',
    amount: '150.00',
    clinic_fee: '20.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: 'N/A',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.Appointment,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Luna Johnson',
  },
  {
    procedureId: 'PROC-2',
    procedureName: 'Tooth Extraction',
    procedureCode: 'D7140',
    procedureDate: '2025-02-12',
    provider: 'Dr. Jane Smith',
    providerFirstName: 'Jane',
    providerLastName: 'Smith',
    coverage: '70%',
    amount: '300.00',
    clinic_fee: '20.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: '15',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.TreatmentPlan,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Pippa Wilkinson',
  },
  {
    procedureId: 'PROC-3',
    procedureName: 'Dental Filling',
    procedureCode: 'D2330',
    procedureDate: '2025-02-16',
    provider: 'Dr. Mark Evans',
    providerFirstName: 'Mark',
    providerLastName: 'Evans',
    coverage: '60%',
    amount: '120.00',
    clinic_fee: '30.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: '4',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.Appointment,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Lyle Kauffman',
  },
  {
    procedureId: 'PROC-DJ1',
    procedureName: 'Initial Consultation',
    procedureCode: 'D0150',
    procedureDate: '2025-02-18',
    provider: 'Dr. John Doe',
    providerFirstName: 'John',
    providerLastName: 'Doe',
    coverage: '80%',
    amount: '250.00',
    clinic_fee: '25.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: 'N/A',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.Appointment,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Daniel Johnson',
  },
  {
    procedureId: 'PROC-EK1',
    procedureName: 'Post-Surgery Follow-up',
    procedureCode: 'D9999',
    procedureDate: '2025-02-22',
    provider: 'Dr. Sophia Lee',
    providerFirstName: 'Sophia',
    providerLastName: 'Lee',
    coverage: '85%',
    amount: '220.00',
    clinic_fee: '30.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: 'N/A',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.Appointment,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Emily Kauffman',
  },
  {
    procedureId: 'PROC-RW1',
    procedureName: 'Oral Examination',
    procedureCode: 'D0120',
    procedureDate: '2025-02-20',
    provider: 'Dr. Mark Evans',
    providerFirstName: 'Mark',
    providerLastName: 'Evans',
    coverage: '70%',
    amount: '160.00',
    clinic_fee: '20.00',
    insurance_plan_id: 'PLAN001',
    allowed_amount: 100,
    write_off: 50,
    estimated_insurance_pay: 50,
    estimated_patient_resp: 50,
    toothNumber: 'N/A',
    toothSurface: 'FM',
    status: ProcedureStatus.Unclaimed,
    source: ProcedureSource.Appointment,
    procedureNotes: [],
    procedureAttachments: [],
    patientName: 'Robert Wilkinson',
  },
]

const mockAppointments: { [key: string]: Appointment[] } = {
  PAT000: [
    {
      id: 'A000',
      date: '2025-02-11',
      type: 'Hygiene',
      provider: 'Dr. John Doe',
    },
    {
      id: 'A002',
      date: '2025-02-12',
      type: 'Follow-up',
      provider: 'Dr. John Doe',
    },
  ],
  PAT001: [
    {
      id: 'A001',
      date: '2025-02-20',
      type: 'Checkup',
      provider: 'Dr. John Doe',
    },
    {
      id: 'A002',
      date: '2025-03-05',
      type: 'Consultation',
      provider: 'Dr. Jane Smith',
    },
    {
      id: 'A003',
      date: '2025-02-12',
      type: 'Surgical Evaluation',
      provider: 'Dr. Jane Smith',
    },
  ],
  PAT002: [
    {
      id: 'A003',
      date: '2025-02-22',
      type: 'Follow-up',
      provider: 'Dr. John Doe',
    },
    {
      id: 'A004',
      date: '2025-02-16',
      type: 'Restoration Check',
      provider: 'Dr. Mark Evans',
    },
  ],
  PAT003: [
    {
      id: 'A004',
      date: '2025-02-28',
      type: 'Oral Surgery',
      provider: 'Dr. Sophia Lee',
    },
  ],
}

const mockTreatmentPlans: { [key: string]: TreatmentPlan[] } = {
  PAT000: [
    {
      id: 'T001',
      name: 'Root Canal Treatment',
      provider: 'Dr. Smith',
      date: '2025-01-10',
      status: 'Planned',
    },
    {
      id: 'T002',
      name: 'Braces Installation',
      provider: 'Dr. Johnson',
      date: '2025-02-15',
      status: 'Ongoing',
    },
  ],
  PAT001: [
    {
      id: 'T001',
      name: 'Root Canal Treatment',
      provider: 'Dr. Smith',
      date: '2025-03-10',
      status: 'Planned',
    },
    {
      id: 'T002',
      name: 'Braces Installation',
      provider: 'Dr. Johnson',
      date: '2025-04-15',
      status: 'Ongoing',
    },
  ],
  PAT002: [
    {
      id: 'T003',
      name: 'Teeth Whitening',
      provider: 'Dr. Brown',
      date: '2025-05-05',
      status: 'Completed',
    },
  ],
  PAT003: [
    {
      id: 'T004',
      name: 'Dental Implant',
      provider: 'Dr. Sophia Lee',
      date: '2025-06-20',
      status: 'Planned',
    },
  ],
}

const mockClaims: Claim[] = [
  {
    id: 'CLM0001',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT000',
    patientName: 'Luna Johnson',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Female',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB001',
    subscriberName: 'Daniel Johnson',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV001',
    providerName: 'Dr. John Doe',
    providerTaxId: '1234567890',
    clinicName: 'Bright Smile Dental',
    groupName: 'Premium Plan',
    groupId: 'GRP001',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-654',
    insuranceProvider: 'ABC Insurance',
    insuranceCarrierId: 'carrier-987',
    insuranceCarrier: 'Blue Shield',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Cleared,
    checkNumber: 'BN123456789',
    claimSource: 0,
    claimType: 'Pre-Authorization',
    claimForm: 'ADA 2025',
    claimAmount: '450.00',
    amountPaid: '200.00',
    procedures: [
      {
        procedureId: 'PR0C-1',
        procedureName: 'Teeth Cleaning',
        procedureCode: 'D1110',
        procedureDate: '2025-02-11',
        provider: 'Dr. John Doe',
        providerFirstName: 'John',
        providerLastName: 'Doe',
        coverage: '80%',
        amount: '150.00',
        clinic_fee: '20.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: 'N/A',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.Appointment,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Luna Johnson',
      },
      {
        procedureId: 'PR0C-5',
        procedureName: 'Post-Treatment Checkup',
        procedureCode: 'D9999',
        procedureDate: '2025-02-12',
        provider: 'Dr. John Doe',
        providerFirstName: 'John',
        providerLastName: 'Doe',
        coverage: '85%',
        amount: '180.00',
        clinic_fee: '25.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: 'N/A',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.Appointment,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Luna Johnson',
      },
      {
        procedureId: 'PROC-6',
        procedureName: 'Fluoride Treatment',
        procedureCode: 'D1206',
        procedureDate: '2025-02-12',
        provider: 'Dr. John Doe',
        providerFirstName: 'John',
        providerLastName: 'Doe',
        coverage: '90%',
        amount: '100.00',
        clinic_fee: '10.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: 'N/A',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.Appointment,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Luna Johnson',
      },
    ],
    attachments: mockAttachments,
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a752e3ff8b6bcbeae60fff_Pippa%20Wilkinson.jpg',
    validity: '2025-12-31',
    appointments: mockAppointments['PAT000'] || [],
    treatmentPlans: mockTreatmentPlans['PAT000'] || [],
    insurancePayments: [mockInsurancePayments[0]],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-10',
  },
  {
    id: 'CLM0002',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT001',
    patientName: 'Pippa Wilkinson',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Female',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB001',
    subscriberName: 'Robert Wilkinson',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV001',
    providerName: 'Dr. John Doe',
    providerTaxId: '1234567890',
    clinicName: 'Bright Smile Dental',
    groupName: 'Premium Plan',
    groupId: 'GRP001',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-654',
    insuranceProvider: 'ABC Insurance',
    insuranceCarrierId: 'carrier-987',
    insuranceCarrier: 'Blue Shield',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Cleared,
    checkNumber: 'BN123456789',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '450.00',
    amountPaid: '200.00',
    procedures: [
      {
        procedureId: 'PROC-2',
        procedureName: 'Tooth Extraction',
        procedureCode: 'D7140',
        procedureDate: '2025-02-12',
        provider: 'Dr. Jane Smith',
        providerFirstName: 'Jane',
        providerLastName: 'Smith',
        coverage: '70%',
        amount: '300.00',
        clinic_fee: '20.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: '15',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.TreatmentPlan,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Pippa Wilkinson',
      },
    ],
    attachments: mockAttachments,
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a752e3ff8b6bcbeae60fff_Pippa%20Wilkinson.jpg',
    validity: '2025-12-31',
    appointments: mockAppointments['PAT001'] || [],
    treatmentPlans: mockTreatmentPlans['PAT001'] || [],
    insurancePayments: [mockInsurancePayments[0]],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-10',
  },
  {
    id: 'CLM0003',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT002',
    patientName: 'Lyle Kauffman',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Male',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB002',
    subscriberName: 'Emily Kauffman',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV002',
    providerName: 'Dr. Jane Smith',
    providerTaxId: '1234567890',
    clinicName: 'Healthy Teeth Clinic',
    groupName: 'Standard Plan',
    groupId: 'GRP002',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-321',
    insuranceProvider: 'XYZ Insurance',
    insuranceCarrierId: 'carrier-123',
    insuranceCarrier: 'Blue Shield',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Deposited,
    checkNumber: 'BN123456789',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '600.00',
    amountPaid: '480.00',
    procedures: [
      {
        procedureId: 'PROC-3',
        procedureName: 'Dental Filling',
        procedureCode: 'D2330',
        procedureDate: '2025-02-16',
        provider: 'Dr. Mark Evans',
        providerFirstName: 'Mark',
        providerLastName: 'Evans',
        coverage: '60%',
        amount: '120.00',
        clinic_fee: '30.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: '4',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.Appointment,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Lyle Kauffman',
      },
    ],
    attachments: [],
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a751cf3f6e8c895132ef81_Lyle%20Kauffman.jpg',
    validity: '2025-12-31',
    appointments: mockAppointments['PAT002'] || [],
    treatmentPlans: mockTreatmentPlans['PAT002'] || [],
    insurancePayments: [mockInsurancePayments[1]],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-10',
  },
  {
    id: 'CLM0004',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT003',
    patientName: 'Kelly Williams',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Female',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB003',
    subscriberName: 'David Williams',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV003',
    providerName: 'Dr. Sophia Lee',
    providerTaxId: '1234567890',
    clinicName: 'Evergreen Dental',
    groupName: 'Elite Plan',
    groupId: 'GRP003',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-888',
    insuranceProvider: 'Delta Dental',
    insuranceCarrierId: 'carrier-222',
    insuranceCarrier: 'Aetna',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.UnderReview,
    checkStatus: StatusTypes.Deposited,
    checkNumber: 'BN987654321',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '800.00',
    amountPaid: '300.00',
    procedures: [
      {
        procedureId: 'PROC-KW1',
        procedureName: 'Dental Implant',
        procedureCode: 'D6010',
        procedureDate: '2025-02-28',
        provider: 'Dr. Sophia Lee',
        providerFirstName: 'Sophia',
        providerLastName: 'Lee',
        coverage: '90%',
        amount: '800.00',
        clinic_fee: '100.00',
        insurance_plan_id: 'PLAN001',
        allowed_amount: 100,
        write_off: 50,
        estimated_insurance_pay: 50,
        estimated_patient_resp: 50,
        toothNumber: '12',
        toothSurface: 'FM',
        status: ProcedureStatus.Unclaimed,
        source: ProcedureSource.Appointment,
        procedureNotes: [],
        procedureAttachments: [],
        patientName: 'Kelly Williams',
      },
    ],
    attachments: [],
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a75148a4117992e1b9582b_Kelly%20Williams.jpg',
    validity: '2025-12-31',
    appointments: mockAppointments['PAT003'] || [],
    treatmentPlans: mockTreatmentPlans['PAT003'] || [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-10',
  },
  {
    id: 'CLM0005',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT004',
    patientName: 'Nikolas Gibbons',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Male',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB004',
    subscriberName: 'Sarah Gibbons',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV004',
    providerName: 'Dr. Mark Evans',
    providerTaxId: '1234567890',
    clinicName: 'Smile Care Dental',
    groupName: 'Basic Plan',
    groupId: 'GRP004',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-777',
    insuranceProvider: 'Guardian Dental',
    insuranceCarrierId: 'carrier-333',
    insuranceCarrier: 'United Healthcare',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Processing,
    checkNumber: 'BN456789123',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '500.00',
    amountPaid: '200.00',
    procedures: [],
    attachments: [],
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a752760883fdab7f9b90d1_Nikolas%20Gibbons.jpg',
    validity: '2025-12-31',
    appointments: [],
    treatmentPlans: [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-10',
  },
  {
    id: 'CLM0007',
    createdAt: '2025-02-15',
    updatedAt: '2025-02-15',
    patientId: 'PAT006',
    patientName: 'Bryan Miles',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Male',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB004',
    subscriberName: 'Alicia Miles',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV004',
    providerName: 'Dr. Mark Evans',
    providerTaxId: '1234567890',
    clinicName: 'Smile Care Dental',
    groupName: 'Basic Plan',
    groupId: 'GRP004',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-777',
    insuranceProvider: 'Guardian Dental',
    insuranceCarrierId: 'carrier-333',
    insuranceCarrier: 'United Healthcare',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Rejected,
    checkStatus: StatusTypes.Cancelled,
    checkNumber: '',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '500.00',
    amountPaid: '0.00',
    procedures: [],
    attachments: [],
    photo:
      'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a752760883fdab7f9b90d1_Nikolas%20Gibbons.jpg',
    validity: '2025-12-31',
    appointments: [],
    treatmentPlans: [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: '',
    paymentDate: '',
  },
  {
    id: 'CLM0006',
    createdAt: '2025-02-19',
    updatedAt: '2025-02-19',
    patientId: 'PAT004',
    patientName: 'Daniel Johnson',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Male',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB001',
    subscriberName: 'Luna Johnson',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV001',
    providerName: 'Dr. John Doe',
    providerTaxId: '1234567890',
    clinicName: 'Bright Smile Dental',
    groupName: 'Premium Plan',
    groupId: 'GRP001',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-654',
    insuranceProvider: 'ABC Insurance',
    insuranceCarrierId: 'carrier-987',
    insuranceCarrier: 'Blue Shield',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Processing,
    checkNumber: 'CHK-DJ123',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '250.00',
    amountPaid: '200.00',
    procedures: [mockProcedures.find((p) => p.procedureId === 'PROC-DJ1')!],
    attachments: [],
    photo: '', // optional
    validity: '2025-12-31',
    appointments: [
      {
        id: 'ADJ-001',
        date: '2025-02-18',
        type: 'Consultation',
        provider: 'Dr. John Doe',
      },
    ],
    treatmentPlans: [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-01',
  },
  {
    id: 'CLM0008',
    createdAt: '2025-02-22',
    updatedAt: '2025-02-22',
    patientId: 'PAT005',
    patientName: 'Emily Kauffman',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Female',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB003',
    subscriberName: 'Lyle Kauffman',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV003',
    providerName: 'Dr. Sophia Lee',
    providerTaxId: '1234567890',
    clinicName: 'Evergreen Dental',
    groupName: 'Elite Plan',
    groupId: 'GRP003',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-888',
    insuranceProvider: 'Delta Dental',
    insuranceCarrierId: 'carrier-222',
    insuranceCarrier: 'Aetna',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Deposited,
    checkNumber: 'CHK-EK222',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '220.00',
    amountPaid: '180.00',
    procedures: [mockProcedures.find((p) => p.procedureId === 'PROC-EK1')!],
    attachments: [],
    photo: '',
    validity: '2025-12-31',
    appointments: [
      {
        id: 'AEK-001',
        date: '2025-02-22',
        type: 'Dental Surgery',
        provider: 'Dr. Sophia Lee',
      },
    ],
    treatmentPlans: [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-05',
  },
  {
    id: 'CLM0009',
    createdAt: '2025-02-20',
    updatedAt: '2025-02-20',
    patientId: 'PAT006',
    patientName: 'Robert Wilkinson',
    patientDateOfBirth: '05/09/1987',
    patientGender: 'Male',
    relationToSubscriber: 'Self',
    subscriberId: 'SUB002',
    subscriberName: 'Pippa Wilkinson',
    subscriberDateOfBirth: '05/09/1987',
    providerEntityType: 'Individual',
    providerId: 'PROV002',
    providerName: 'Dr. Mark Evans',
    providerTaxId: '1234567890',
    clinicName: 'Healthy Teeth Clinic',
    groupName: 'Standard Plan',
    groupId: 'GRP002',
    insurancePlanId: 'PLAN001',
    insuranceProviderId: 'ins-321',
    insuranceProvider: 'XYZ Insurance',
    insuranceCarrierId: 'carrier-123',
    insuranceCarrier: 'Blue Shield',
    insuranceCarrierPayerCode: '123456',
    status: ClaimStatus.Approved,
    checkStatus: StatusTypes.Cleared,
    checkNumber: 'CHK-RW321',
    claimSource: 0,
    claimType: 'Claims',
    claimForm: 'ADA 2025',
    claimAmount: '160.00',
    amountPaid: '100.00',
    procedures: [mockProcedures.find((p) => p.procedureId === 'PROC-RW1')!],
    attachments: [],
    photo: '',
    validity: '2025-12-31',
    appointments: [
      {
        id: 'ARW-001',
        date: '2025-02-20',
        type: 'Oral Exam',
        provider: 'Dr. Mark Evans',
      },
    ],
    treatmentPlans: [],
    insurancePayments: [],
    entityType: 'Individual',
    modeOfPayment: 'Wire',
    paymentDate: '2025-03-07',
  },
]

const claimsData = mockClaims
export default claimsData

export {
  mockClaims,
  mockProcedures,
  mockAttachments,
  mockNotes,
  mockAppointments,
  mockTreatmentPlans,
}
